module Meevo.Components.Controls {
    'use strict';

    import ISettingsPageController = Meevo.Components.BaseClasses.ISettingsPageController;

    export class MeevoSettingsPageComponent implements angular.IComponentController {

        context: ISettingsPageController<any>;
    }

    angular.module('meevo.components.controls')
        .component('meevoSettingsPage', {
            controller: MeevoSettingsPageComponent,
            templateUrl: 'app/components/controls/settings-page/settings-page.component.html',
            bindings: {
                context: '<'
            },
            transclude: {
                pageBody: 'pageBody'
            }
        });
}
